import React from 'react';
import withRouter from '../utils/wrappers/WithRouter';
import Misc from '@components/Misc';
import { EAclAction } from '@ts/ui-models';
import { Button, Grid, Icon, TextInput, IconButton, Select } from '@ts/storybook';
import WithAllPropsApp from '@utils/wrappers/WithAllPropsApp';

const _ = require('lodash');
const PropTypes = require('prop-types');
const createReactClass = require('create-react-class');
const fileDownload = require('js-file-download');
const { parse } = require('json2csv');
const act = require('@flux/actions/actView');
const k = require('@gral/constants');
const QuickFind = require('@components/QuickFind').default;
const App = require('@gral/app');
const Error403 = require('@components/Errors/403').default;

const { Fab } = require('@mui/material');
const { LinearProgress } = require('@mui/material');

const { withTranslation } = require('react-i18next');

const _getRawValue = function (row, column) {
  const fn = column.rawValue != null ? column.rawValue : o => o.get(column.name);
  return fn(row);
};

const _getFilterValue = function (row, column) {
  let left;
  const rawValue = row.get('_colValues')[column.idx];
  if (rawValue == null) {
    return '';
  }
  const fn = column.filterValue != null ? column.filterValue : () => rawValue;
  return (left = fn(row, rawValue)) != null ? left : '';
};

const _getSortValue = function (row, column) {
  let left;
  const rawValue = row.get('_colValues')[column.idx];
  if (rawValue == null) {
    return '';
  }
  const fn = column.sortValue != null ? column.sortValue : () => rawValue;
  return (left = fn(row, rawValue)) != null ? left : '';
};

const _renderValue = function (row, column, fnFilter) {
  let left;
  const rawValue = row.get('_colValues')[column.idx];
  if (rawValue == null) {
    return '';
  }
  const fn = column.render != null ? column.render : () => rawValue;
  return (left = fn(row, rawValue, fnFilter)) != null ? left : '';
};

const MAX_PAGINATION_BUTTONS = 6;
const MOBILE_BREAKPOINT = 500;

const DataTable = createReactClass({
  displayName: 'DataTable',
  propTypes: {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    fnFilter: PropTypes.func,
    fFiltered: PropTypes.bool,
    editUrl: PropTypes.string,
    columns: PropTypes.array.isRequired,
    pkColumn: PropTypes.string.isRequired,
    // rows:             React.PropTypes.object
    initSortAttr: PropTypes.string,
    fInitReverseSort: PropTypes.bool,
    addIcon: PropTypes.string,
    fAllowQuickSearch: PropTypes.bool,
    fAllowEdit: PropTypes.bool,
    fAllowCreate: PropTypes.bool,
    fPortal: PropTypes.bool,
    fnChange: PropTypes.func,
    fnOnRowCount: PropTypes.func, // only for portals
    downloadOptions: PropTypes.object,
    defaultCreationProperties: PropTypes.object,
    entity: PropTypes.string,
    fFilterDeleted: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      fFiltered: false,
      initSortAttr: null,
      fInitReverseSort: false,
      addIcon: 'content-add',
      fAllowQuickSearch: true,
      fAllowQuickFind: true,
      fAllowEdit: true,
      fAllowCreate: true,

      fAllowDownload: false,
      fFilterDeleted: true,
      defaultCreationProperties: null,
      mobileBreakpoint: MOBILE_BREAKPOINT,
    };
  },
  getInitialState() {
    return {
      selected: null, // selected model
      sortAttr: this.props.initSortAttr,
      fReverseSort: this.props.fInitReverseSort,
      quickSearch: this.props.externalQuickSearch || '',
      activePage: 1,
      itemsPerPage: Number(sessionStorage.getItem('itemsPerPage')) || (this.props.itemsPerPage ? this.props.itemsPerPage : 10),
      componentWidth: null, // unknown at mount
      fDecommissioned: false,
    };
  },

  UNSAFE_componentWillMount() {
    if (this.props.entity) {
      if (!App.cxStore.checkPermission(this.props.entity, EAclAction.READ)) {
        this._NOT_AUTHORIZED = true;
        return;
      }
    }

    this._pkColumn = _.find(this.props.columns, column => column.name === this.props.pkColumn);
    if (this._pkColumn == null) {
      throw new Error(`Cannot find column ${this.props.pkColumn}`);
    }
    return (this.fAllowDownload = this.props.fAllowDownload);
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.externalQuickSearch != null) {
      if (nextProps.externalQuickSearch !== this.props.externalQuickSearch) {
        return this.setState({ quickSearch: nextProps.externalQuickSearch });
      }
    }
  },
  componentDidUpdate() {
    if (this.props.fnOnRowCount) {
      return this.props.fnOnRowCount(this._rows.count());
    }
  },

  render() {
    if (this._NOT_AUTHORIZED === true) {
      return (
        <div>
          <Error403 />
        </div>
      );
    }
    return <>{this._render()}</>;
  },

  _render() {
    if (this.props.rows == null) {
      return (
        <LinearProgress
          mode="indeterminate"
          style={{
            width: '100%',
            marginTop: '10px',
          }}
        />
      );
    }
    this._fMobile = false;
    this._prepareCols();
    if (this.props.fFilterDeleted) {
      this._initialRows = this._filterDeleted(this.props.rows);
    } else {
      this._initialRows = this.props.rows;
    }
    let rows = this._initialRows;
    rows = this._preprocess(rows);
    rows = this._quickSearch(rows);
    this._rows = this._sort(rows);
    this._numPages = Math.ceil(this._rows.size / this.state.itemsPerPage);
    this._activePage = Math.min(this._numPages, this.state.activePage);

    return (
      <Grid container justifyContent="center" size={{ xs: 12 }} id="data-table">
        <Misc.NewPaperWithPadding>
          {this._renderHeader()}
          {this._renderTable()}
          {this._renderPagination()}
          {this._renderFAB()}
        </Misc.NewPaperWithPadding>
      </Grid>
    );
  },

  _renderHeader() {
    return (
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid size={{ xs: 'auto' }} style={_style.title.block}>
          <span style={_style.title.titleSubtitle}>
            <b>{this.props.title}</b>
            {this._renderSubtitle()}
            {this.props.btnShowModal && this.props.btnShowModal()}
          </span>
          {this._renderRemoveFilter()}
        </Grid>
        <Grid container size={{ xs: 'auto' }} alignItems="center" justifyContent="flex-end" spacing={1}>
          {this._renderQuickFind()}
          {this._renderSearchInput()}
          {this._renderDownloadButton()}
          {this._renderCreateButton()}
        </Grid>
        {/* <div style={{ clear: 'both' }} /> */}
      </Grid>
    );
  },

  _renderSubtitle() {
    if (this.props.subtitle == null) {
      return;
    }
    return <span style={_style.title.subtitle}>{this.props.subtitle}</span>;
  },

  _renderRemoveFilter() {
    if (!this.props.fFiltered || !this.props.fRemoveFilterButton) {
      return <div style={_style.title.removeFilterPlaceholder}> </div>;
    }
    return;
    return <Button onClick={() => this.props.fnFilter({})} variant="outlined" size="small" label="Remove filter" />;
  },

  _renderQuickFind() {
    if (!(this.props.modelName && this.props.fAllowQuickFind)) {
      return;
    }
    return <QuickFind modelName={this.props.modelName} pathToStore="itemsPage" />;
  },

  _renderSearchInput() {
    if (!this.props.fAllowQuickSearch) {
      return;
    }
    return (
      <Grid container size={{ xs: 'auto' }} justifyContent="center" alignItems="center">
        <Grid key="searchInput" onKeyUp={this._handleQuickSearchKeyUp}>
          <TextInput
            placeholder="Filter result"
            value={this.state.quickSearch}
            onChangeValue={this._handleQuickSearchChangeValue}
            disabled={!this._initialRows.size}
          //style={_style.tools.searchInput}
          />
        </Grid>
        <Grid>
          <Button
            key="searchClear"
            variant="text"
            label="Clear filter"
            onClick={this._handleQuickSearchClear}
            disabled={_.isEmpty(this.state.quickSearch)}
            style={_style.tools.searchClear}
          />
        </Grid>
      </Grid>
    );
  },

  _renderDownloadButton() {
    if (!this.fAllowDownload) {
      return;
    }
    return (
      <IconButton onClick={this._handleDownload} style={_style.tools.createIcon}>
        <Icon icon="download" />
      </IconButton>
    );
  },

  _renderCreateButton() {
    if (this.props.entity) {
      if (!App.cxStore.checkPermission(this.props.entity, 'create')) {
        return;
      }
    }
    if (!this.props.fAllowCreate) {
      return;
    }
    if (this.props.editUrl == null) {
      return;
    }

    return (
      <IconButton onClick={this._handleNew} style={_style.tools.createIcon}>
        <Icon icon={this.props.addIcon} />
      </IconButton>
    );
  },

  _renderTable() {
    let table;
    this._rowStart = (this._activePage - 1) * this.state.itemsPerPage;
    this._rowEnd = this._rowStart + this.state.itemsPerPage;

    if (this._fMobile) {
      table = (
        <div key={this._activePage}>
          {this._rows.slice(this._rowStart, this._rowEnd).map((row, idxRow) => this._renderRow(row, idxRow))}
        </div>
      );
    } else {
      table = (
        <table key={this._activePage} style={_style.table.table}>
          <thead>
            <tr style={_style.table.row({ fHeader: true })}>
              {this.props.columns.map((column, idxCol) => this._renderColHeader(column, idxCol))}
            </tr>
          </thead>
          <tbody>
            <>{this._rows.slice(this._rowStart, this._rowEnd).map((row, idxRow) => this._renderRow(row, idxRow))}</>
          </tbody>
        </table>
      );
    }
    return table;
  },

  _renderColHeader(column, idxCol) {
    if (column.fHidden) {
      return null;
    }
    const colName = column.name;
    const fnLabel = column.fnLabel != null ? column.fnLabel : () => _.capitalize(colName);
    return (
      <td key={idxCol} style={this._styleCell({ idxCol, fHeader: true, colName })}>
        <span onClick={this._handleColumnHeaderClick(colName)} style={{ display: 'flex', alignItems: 'center' }}>
          {fnLabel()}
          {this._renderColSorted(colName)}
        </span>
      </td>
    );
  },

  _renderColSorted(colName) {
    if (colName === this.state.sortAttr) {
      const icon = 'Sort';
      return <Icon icon={icon} style={this._styleIconSorted()} />;
    }
  },
  _renderRow(row, idxRow) {
    let tableRow;
    const id = row.get(this.props.pkColumn);
    const fSelected = (this.state.selected != null ? this.state.selected.get(this.props.pkColumn) : undefined) === id;
    if (this._fMobile) {
      tableRow = (
        <div
          key={id + '' + idxRow}
          data-idx-row={idxRow}
          onClick={() => this._clickRow(row)}
          style={_style.tableMobile.row({ fSelected })}
        >
          {this.props.columns.map((column, idxCol) => this._renderCellMobile(row, column, idxCol))}
        </div>
      );
    } else {
      tableRow = (
        <tr
          key={id + '' + idxRow}
          data-idx-row={idxRow}
          onClick={() => this._clickRow(row)}
          style={_style.table.row({ fSelected })}
        >
          {this.props.columns.map((column, idxCol) => this._renderCell(row, column, idxCol))}
        </tr>
      );
    }
    return tableRow;
  },

  _renderCellMobile(row, column, idxCol) {
    if (column.fHidden) {
      return null;
    }
    const colName = column.name;
    const fnLabel = column.fnLabel != null ? column.fnLabel : () => _.capitalize(colName);
    return (
      <div key={idxCol}>
        <div style={_style.tableMobile.colName}>{fnLabel()}</div>
        <div style={_style.tableMobile.value}>{_renderValue(row, column, this.props.fnFilter)}</div>
      </div>
    );
  },

  _renderCell(row, column, idxCol) {
    if (column.fHidden) {
      return null;
    }
    return (
      <td key={idxCol} style={this._styleCell({ idxCol, colName: column.name })}>
        {_renderValue(row, column, this.props.fnFilter)}
      </td>
    );
  },

  _renderPagination() {
    let rowStr;
    const numRows = this._rows.size;
    if (this._activePage > 0) {
      const rowStart = this._rowStart + 1;
      const rowEnd = Math.min(numRows, this._rowEnd);
      rowStr = `${this.props.t('Showing')} ${rowStart}-${rowEnd} ${this.props.t('of')} ${numRows} ${this.props.t('elements')}`;
    } else {
      rowStr = this.props.t('Showing 0 elements');
    }
    const itemsPerPageMenu = [
      {
        fnValue() {
          return 10;
        },
        fnLabel: () => this.props.t('10 per page'),
      },
      {
        fnValue() {
          return 25;
        },
        fnLabel: () => this.props.t('25 per page'),
      },
      {
        fnValue() {
          return 50;
        },
        fnLabel: () => this.props.t('50 per page'),
      },
      {
        fnValue() {
          return 100;
        },
        fnLabel: () => this.props.t('100 per page'),
      },
    ];
    return (
      <Grid container spacing={3} alignItems="center">
        <Grid size={{ xs: 'auto' }}>
          <Select
            value={this.state.itemsPerPage}
            onChange={this._handleChangeItemsPerPage}
            options={itemsPerPageMenu}
            sx={{ marginBottom: '10px' }}
          />
        </Grid>
        <Grid size={{ xs: 'auto' }}>{rowStr}</Grid>
        <Grid size={{ xs: 'auto' }}>
          <IconButton disabled={this._activePage === 1} onClick={this._handlePreviousPage}>
            <Icon icon="navigation-chevron-left" />
          </IconButton>
          <IconButton disabled={this._activePage === this._numPages} onClick={this._handleNextPage}>
            <Icon icon="navigation-chevron-right" />
          </IconButton>
        </Grid>
      </Grid>
    );
  },

  _renderFAB() {
    if (this.props.fPortal) {
      return;
    }
    if (this.props.fAllowEdit && this.props.editUrl == null) {
      //console.log('Editing is allowed, but configuration is incomplete');
      return;
    }
    if (this.state.selected == null) {
      return;
    }
    const fabs = [];
    if (this.state.fDecommissioned === true) {
      return;
    }
    if (this.props.fAllowEdit && (App.cxStore.checkPermission(this.props.entity, 'edit') || !this.props.entity)) {
      fabs.push(
        <div style={k.gui.styles.fab} key="edit">
          <Fab
            color="primary"
            size="medium"
            onClick={this._handleFAB({
              fnArgs: { id: this._getPKforSelection(), action: 'edit' },
              fnAction: this._goTo,
            })}
            disabled={this.state.selected == null}
            title={'Edit'}
          >
            <Icon icon="editor-mode-edit" />
          </Fab>
        </div>
      );
    }
    const bottom = 45;
    let right = 24;
    if (this.props.extraFABs) {
      this.props.extraFABs.forEach(FAB => {
        if (this.props.fAllowEdit) {
          right += 64;
        }
        return fabs.push(
          <div style={{ position: 'fixed', bottom, right }} key={FAB.fnAction}>
            <Fab
              color="primary"
              size="medium"
              onClick={this._handleFAB(FAB)}
              disabled={this.state.selected == null}
              title={FAB.title}
            >
              <Icon icon={FAB.icon} />
            </Fab>
          </div>
        );
      });
    }
    return <div>{fabs}</div>;
  },

  _handleColumnHeaderClick(colName) {
    // <FloatingActionButton disabled={not @state.selected?} onClick={@_handleFAB(FAB.action)}>
    return ev => {
      let fReverseSort;
      const curSortAttr = this.state.sortAttr;
      let sortAttr = colName;
      if (colName === curSortAttr) {
        if (this.state.fReverseSort === false) {
          fReverseSort = true;
        } else {
          fReverseSort = false;
        }
      } else {
        fReverseSort = false;
      }
      return this.setState({ sortAttr, fReverseSort });
    };
  },

  _handleQuickSearchKeyUp(ev) {
    if (ev.which === k.keys.ESC) {
      return this._handleQuickSearchClear();
    }
  },
  _handleQuickSearchChangeValue(value) {
    return this.setState({ quickSearch: value });
  },
  _handleQuickSearchClear() {
    return this.setState({ quickSearch: '' });
  },

  _clickRow(row) {
    const curSelection = this.state.selected;
    if (curSelection == null || this._getPK(row) !== this._getPK(curSelection)) {
      return this._changeSelection(row);
    }
    return this._changeSelection(null);
  },
  _handlePreviousPage(ev) {
    this.setState({ activePage: this.state.activePage - 1 });
    if (this.state.selected) {
      return this._changeSelection(null);
    }
  },
  _handleNextPage(ev) {
    this.setState({ activePage: this.state.activePage + 1 });
    if (this.state.selected) {
      return this._changeSelection(null);
    }
  },
  _handleChangeItemsPerPage(val) {
    sessionStorage.setItem('itemsPerPage', val);
    return this.setState({ itemsPerPage: val });
  },

  _changeSelection(selected) {
    this.setState({ selected });
    return typeof this.props.fnChange === 'function' ? this.props.fnChange(selected) : undefined;
  },

  _handleDownload() {
    const fields = this.props.downloadOptions.fields != null ? this.props.downloadOptions.fields : null; // null means all dataset will be dumped to csv
    const fileName =
      this.props.downloadOptions.fileName != null
        ? this.props.downloadOptions.fileName
        : `${this.props.title}Export-${new Date().toISOString().substring(0, 19)}.csv`;
    const items = this.props.rows.toJS();
    const csv = parse(items, { fields });
    return fileDownload(csv, fileName);
  },

  _handleNew() {
    if (this.props.editDataPath != null) {
      if (this.state.selected != null) {
        let newModel = this.state.selected;
        for (const attr of ['id', '_colValues', 'createdAt', 'creatorId', 'updatedAt', 'updaterId']) {
          newModel = newModel.remove(attr);
        }
        if (this.props.defaultCreationProperties) {
          newModel = newModel.merge(this.props.defaultCreationProperties);
        }
        act.setDataPath(this.props.editDataPath, newModel);
        act.markAsStale(this.props.editDataPath);
      } else if (this.props.defaultCreationProperties) {
        act.setDataPath(this.props.editDataPath, this.props.defaultCreationProperties);
      }
    }
    return this.props.navigate(`${this.props.editUrl}/new`);
  },

  _goTo(args) {
    return this.props.navigate(`${this.props.editUrl}/${args.id}/${args.action}`, {
      cleanDatapath: false,
    });
  },

  _handleFAB(fab) {
    return event => {
      const id = this._getPKforSelection();
      if (!fab.fnArgs) {
        fab.fnArgs = {};
      }
      fab.fnArgs.id = id;
      fab.fnArgs.selected = this.state.selected;
      return fab.fnAction(fab.fnArgs);
    };
  },

  _prepareCols() {
    return _.each(this.props.columns, (column, idx) => (column.idx = idx));
  },

  // Keep only those records that are either "positively alive" or "we don't know"
  _filterDeleted(rows) {
    let filteredRows;
    const showDecomm = this.state.fDecommissioned;
    if (showDecomm) {
      // show decommisioned assets
      filteredRows = rows.filter(row => {
        const isAlive = row.get('isAlive');
        return !isAlive;
      });
    } else {
      filteredRows = rows?.filter(row => row && (!row?.hasOwnProperty('isAlive') || row?.get('isAlive')));
    }

    return filteredRows;
  },

  _preprocess(rows) {
    const preprocessedRows = rows.map(row => {
      const colValues = _.map(this.props.columns, column => _getRawValue(row, column));
      return row.set('_colValues', colValues);
    });
    return preprocessedRows;
  },

  _quickSearch(rows) {
    const quickSearchStr = this.state.quickSearch.toLowerCase();
    if (_.isEmpty(quickSearchStr)) {
      return rows;
    }
    const { columns } = this.props;
    const foundRows = rows.filter(row =>
      _.some(columns, (column, idx) => {
        if (!(column.fAllowQuickSearch != null ? column.fAllowQuickSearch : true)) {
          return false;
        }
        let quickSearchValue = _getFilterValue(row, column);
        quickSearchValue = `${quickSearchValue}`.toLowerCase();
        return quickSearchValue.indexOf(quickSearchStr) >= 0;
      })
    );
    return foundRows;
  },

  _sort(rows) {
    const { sortAttr } = this.state;
    if (sortAttr == null) {
      return rows;
    }
    const { fReverseSort } = this.state;
    const column = _.find(this.props.columns, o => o.name === sortAttr);
    const sortedRows = rows.sort((row1, row2) => {
      let result;
      let a = _getSortValue(row1, column);
      let b = _getSortValue(row2, column);
      if (_.isString(a)) {
        a = a.toLowerCase();
      }
      if (_.isString(b)) {
        b = b.toLowerCase();
      }
      if (a === b) {
        a = this._getPK(row1);
        b = this._getPK(row2);
      }
      if (a < b) {
        result = -1;
      } else if (a > b) {
        result = +1;
      } else {
        result = 0;
      } // should never happen
      return result * (fReverseSort ? -1 : +1);
    });
    return sortedRows;
  },

  _getPKforSelection() {
    if (this.state.selected == null) {
      return null;
    }
    return this._getPK(this.state.selected);
  },

  _getPK(row) {
    return _getRawValue(row, this._pkColumn);
  },

  _styleIconSorted() {
    return {
      marginLeft: 10,
      transform: this.state.fReverseSort ? 'rotate(180deg)' : 'rotate(0deg)',
      height: 26,
    };
  },
  _styleCell(options) {
    if (options == null) {
      options = {};
    }
    const fFirstCol = options.idxCol === 0;
    const fLastCol = options.idxCol === this.props.columns.length - 1;
    const style = {
      paddingRight: fLastCol ? 24 : 6,
      width: options.colName === 'action' ? '1%' : undefined,
      whiteSpace: options.colName === 'action' ? 'nowrap' : undefined,
      paddingLeft: options.colName === 'action' && options.fHeader ? 16 : fFirstCol ? 24 : 6,
      paddingTop: options.fHeader ? 15 : 8,
      paddingBottom: options.fHeader ? 15 : 8,
      fontWeight: options.fHeader ? 'bold' : undefined,
      borderLeft: '0px solid white',
      borderRight: '0px solid white',
      borderBottom: options.fHeader ? `1px solid ${k.gui.colors.lighterGray}` : undefined,
    };
    // # cursor: 'pointer'
    return style;
  },
});

var _style = {
  outer: {
    paddingTop: 10,
  },
  // marginBottom: 70
  superheader(options) {
    if (options == null) {
      options = {};
    }
    return {
      borderBottom: `1px solid ${k.gui.colors.lighterGray}`,
      width: '100%',
      overflowX: 'hidden',
      overflowY: 'hidden',
      lineHeight: '36px',
      paddingLeft: options.fMobile ? 10 : 24,
      paddingRight: 8,
      boxSizing: 'border-box',
    };
  },
  title: {
    block: {
      float: 'left',
      marginTop: 10,
      // whiteSpace: 'nowrap'
      display: 'flex',
      maxWidth: '50%',
    },
    titleSubtitle: {
      fontSize: 20,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    mobileTitle: {
      fontSize: 20,
    },
    subtitle: {
      paddingLeft: 5,
      color: k.gui.colors.mediumGray,
      marginRight: 8,
    },
    mobileSubtitle: {
      fontSize: 16,
    },
    removeFilterPlaceholder: {
      display: 'inline-block',
      height: 36,
      lineHeight: '39px',
      width: 3,
      backgroundColor: 'red',
      opacity: 0,
    },
  },
  tools: {
    block(options) {
      if (options == null) {
        options = {};
      }
      return {
        float: options.fMobile ? 'left' : 'right',
        whiteSpace: 'nowrap',
      };
    },
    searchInput: {
      width: 150,
    },
    searchClear: {
      marginRight: 10,
    },
    createIcon: {
      position: 'relative',
      top: 7,
    },
  },
  table: {
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      borderBottom: '1px solid #e0e0e0',
    },
    row(options) {
      // height: 40
      if (options == null) {
        options = {};
      }
      return {
        backgroundColor: options.fSelected ? k.gui.colors.lighterGray : undefined,
        verticalAlign: 'baseline',
      };
    },
  },
  tableMobile: {
    row(options) {
      if (options == null) {
        options = {};
      }
      return {
        padding: 10,
        backgroundColor: options.fSelected ? k.gui.colors.lighterGray : undefined,
        borderBottom: `1px solid ${k.gui.colors.lighterGray}`,
      };
    },
    colName: {
      display: 'inline-block',
      fontWeight: 'bold',
      width: '38%',
    },
    value: {
      display: 'inline-block',
      width: '62%',
    },
  },
};

export default withRouter(withTranslation()(WithAllPropsApp(DataTable)));
